import { useContext, useEffect, useMemo, useState } from "react";
import { usePagination, useTable } from "react-table";
import { Get } from "../Rutas/ApiRest";
import "../index.css"
import { RastreoInicial } from "../Model/Tablas/RastreoCarga";
import { Contexto } from "../Context/Contexto";
import { GuiaBusquedaCont } from "../Context/BusquedaGuiaContext";
import { tokens } from "../Context/Tokens";
import { MensajeContActualizacion } from "../Context/MensajeContextActualizacion";

function OrdenesRetiro(prop:any)
{
    const {tok}=useContext(tokens)
    const {Cli}=useContext(Contexto)
    const {GuiaBusqueda}=useContext(GuiaBusquedaCont)
    const {SetLoading}=useContext(MensajeContActualizacion)
    const datos=[
        RastreoInicial
      ]
      const columns=useMemo(() => prop.Columna, [])
      const dato=useMemo(() => datos, [])
      const [data,Setdata]=useState(dato)
      var cantidad=0
     useEffect(()=>{
        SetLoading(true)
        ActualizarDatos();
        
     },[])

     useEffect(()=>{
        SetLoading(true)
        ActualizarDatos();
     },[GuiaBusqueda])

     useEffect(()=>{
        SetLoading(true)
        ActualizarDatos();
        
     },[Cli.Eleccion])

     const ActualizarDatos=()=>
     {
        if(Cli.lCasilla[Cli.Eleccion].ecode!=undefined)
        {
            if(Cli.lCasilla[Cli.Eleccion].ecode!="")
            {
                const historialcargas=Get(prop.Link.replace("@ecode",Cli.lCasilla[Cli.Eleccion].ecode).replace("@guiahija",GuiaBusqueda),"application/json",tok)
                historialcargas.then(resultado=>{Setdata(resultado);SetLoading(false)})
            }
        }
        SetLoading(false);
     }

          const {
            getTableProps, 
            getTableBodyProps, 
            headerGroups, 
            page,
            nextPage,
            previousPage,
            canNextPage,
            canPreviousPage,
            pageOptions,
            gotoPage,
            pageCount,
            state,
            prepareRow,
        } = useTable({
                // @ts-ignore
                columns,
                data,
            },
            usePagination
        );

        const { pageIndex } = state
    return (
        <>
        {data.length===0?<div><div className="alert au-alert-success alert-dismissible fade show au-alert au-alert--100per" role="alert" id={prop.Categoria}> <span className="content" >Sin Ordenes para retirar</span>

                    </div></div>:<div className="row">
            <div className="col-12 py-2 py-sm-0">
              <div className="table-responsive" >
                     <table  {...getTableProps()} className="table table-hover table-sm table-bordered">
                       <thead style={{verticalAlign:"middle"}}>
                           {headerGroups.map((headerGroup) => (
                               <tr {...headerGroup.getHeaderGroupProps()}>
                                   {headerGroup.headers.map((column) => (
                                       <th {...column.getHeaderProps()}>
                                           {column.render('Header')}
                                       </th>
                                   ))}
                               </tr>
                           ))}
                       </thead>

                       <tbody {...getTableBodyProps()} style={{verticalAlign:"top",textAlign:"center"}}>
                           {page.map((row: any) => {
                               prepareRow(row)
                               let colore="#0d6efd"
                                if(row.cells[0].value===GuiaBusqueda+"")
                                {
                                    colore="#FFD700"
                                }
                               return (
                                   <tr {...row.getRowProps()} style={{background:row.cells[0].value===GuiaBusqueda+""?"#00ad5f":"",color:row.cells[0].value+""===GuiaBusqueda?"#fff":""}}>
                                       {row.cells.map((cell: any) => {
                                        var datoss=""
                                        if(cell.column.Header==="Imagenes" && cell.value!=undefined && cell.value!="-")
                                        {
                                          datoss=cell.value.split(',')
                                          cantidad=cantidad+1
                                        }
                                           return (
                                            cell.column.Header==="Imagenes" && cell.value!="-"?
                                            datoss.length==2?<td {...cell.getCellProps()}>
                                                <a className="nav-link collapsed" data-bs-target={"#components-n"+cantidad} data-bs-toggle="collapse" style={{cursor:"pointer",color:colore}}>Imagenes</a>
                                                    <ul id={"components-n"+cantidad} className="nav-content collapse" data-bs-parent="#sidebar-nav" style={{padding:"0"}}>
                                                         {datoss[0]!="-"?<div style={{paddingBottom:"20px"}}><a href={"https://apps.eshopex.cl/admin_sac/desconsolidador/getArchive?nombreArchivo="+datoss[0]} style={{color:colore}}> {datoss[0]} </a></div>  :null}
                                                         {datoss[1]!="-"?<a  href={"https://apps.eshopex.cl/admin_sac/desconsolidador/getArchive?nombreArchivo="+datoss[1]} style={{color:colore}}> {datoss[1]} </a> :null}
                                                    </ul>
                                                    
                                                </td>:
                                            <td {...cell.getCellProps()} >-</td>
                                            :<td {...cell.getCellProps()} >{cell.render('Cell')}</td>
                                           );
                                       })}
                                   </tr>
                               );
                           })}
                       </tbody>
                   </table>   
              </div>
			  </div>
		  </div>

                    }

{data.length>10?<div className="table-pagination" style={{margin: '5px', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <a href={"#"+prop.Categoria}>
                    
                    <button onClick={() => previousPage()} disabled={!canPreviousPage} className="btn btn-success">
                        Anterior
                    </button>
                </a>
                <span>
                    <strong style={{display: 'block', width: '100px', textAlign: 'center'}}>
                        {pageIndex + 1} / {pageOptions.length} 
                    </strong>
                </span>
                <a href={"#"+prop.Categoria}>
                    <button onClick={() => nextPage()} disabled={!canNextPage} className="btn btn-success" >
                        Siguiente
                    </button>
                   
                </a>
                
            </div>:null}

        </>
    )
}

export default OrdenesRetiro;